import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["colors", "shape", "disabled", "className", "size", "bordered", "children", "htmlType", "clsPrefix", "isSubmit", "loading", "loadingText", "icon", "danger", "ghost", "type", "block"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '../../wui-icon/src';
import { WebUI } from "../../wui-core/src/index.js";
import omit from 'omit.js';
var propTypes = {
  /**
   * @title 尺寸
   */
  size: PropTypes.oneOf(['sm', 'md', 'xg', 'lg', 'small', 'large', 'middle']),

  /**
   * @title 样式
   */
  style: PropTypes.object,

  /**
   * @title 形状
   */
  shape: PropTypes.oneOf(['block', 'round', 'border', 'squared', 'floating', 'pillRight', 'pillLeft', 'icon']),
  bordered: PropTypes.bool,

  /**
   * @title 是否有icon图标
   */
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),

  /**
   * @title 是否有loading状态
   */
  loading: PropTypes.bool,

  /**
  * @title 是否有loading提示
  */
  loadingText: PropTypes.string,

  /**
  * @title 类型
  */
  colors: PropTypes.oneOf(['primary', 'secondary', 'accent', 'success', 'info', 'warning', 'danger', 'dark', 'light', 'default']),

  /**
   * @title 是否禁用
   * @veIgnore
   */
  disabled: PropTypes.bool,

  /**
   * @title 类名
   * @veIgnore
   */
  className: PropTypes.string,

  /**
   * @title <button> 的 type
   * @veIgnore
   */
  htmlType: PropTypes.oneOf(['submit', 'button', 'reset']),

  /**
   * @title 类型
   */
  type: PropTypes.oneOf(['default', 'ghost', 'danger', 'primary', 'dashed', 'text', 'link']),

  /**
   * @title 是否作为form的提交按钮
   */
  isSubmit: PropTypes.bool,

  /**
   * @title 是否危险按钮
   */
  danger: PropTypes.bool,

  /**
   * @title 是否幽灵按钮
   */
  ghost: PropTypes.bool,

  /**
   * @title 是否为块级按钮
   */
  block: PropTypes.bool
};
var defaultProps = {
  disabled: false,
  htmlType: 'button',
  bordered: false,
  isSubmit: false,
  loading: false,
  danger: false,
  ghost: false,
  loadingText: "",
  size: null,
  shape: null,
  icon: null,
  colors: null,
  type: null
};
var sizeMap = {
  sm: 'sm',
  md: 'md',
  xg: 'xg',
  lg: 'lg',
  small: 'sm',
  middle: 'md',
  large: 'lg'
},
    colorsMap = {
  primary: 'primary',
  secondary: 'secondary',
  accent: 'accent',
  success: 'success',
  info: 'info',
  warning: 'warning',
  danger: 'danger',
  dark: 'dark',
  light: 'light'
},
    typeMap = {
  default: 'default',
  ghost: 'ghost',
  danger: 'danger',
  dashed: 'dashed',
  text: 'text',
  link: 'link',
  //tool: 'tool',
  primary: 'primary'
},
    shapeMap = {
  block: 'block',
  round: 'round',
  border: 'border',
  squared: 'squared',
  floating: 'floating',
  pillRight: 'pill-right',
  pillLeft: 'pill-left',
  icon: 'icon'
};
var Button = (_dec = WebUI({
  name: "button",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper(Button);

  function Button(props) {
    _classCallCheck(this, Button);

    return _super.call(this, props);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          colors = _this$props.colors,
          shape = _this$props.shape,
          disabled = _this$props.disabled,
          className = _this$props.className,
          size = _this$props.size,
          bordered = _this$props.bordered,
          children = _this$props.children,
          htmlType = _this$props.htmlType,
          clsPrefix = _this$props.clsPrefix,
          isSubmit = _this$props.isSubmit,
          loading = _this$props.loading,
          loadingText = _this$props.loadingText,
          icon = _this$props.icon,
          danger = _this$props.danger,
          ghost = _this$props.ghost,
          type = _this$props.type,
          block = _this$props.block,
          others = _objectWithoutProperties(_this$props, _excluded);

      var isDisabled = disabled;
      var isBordered = bordered;
      var clsObj = {};

      if (className) {
        clsObj[className] = true;
      }

      if (sizeMap[size]) {
        clsObj["".concat(clsPrefix, "-").concat(sizeMap[size])] = true;
      }

      if (shapeMap[shape]) {
        clsObj["".concat(clsPrefix, "-").concat(shapeMap[shape])] = true;
      }

      if (block) {
        clsObj["".concat(clsPrefix, "-block")] = true;
      }

      if (colorsMap[colors]) {
        clsObj["".concat(clsPrefix, "-").concat(colorsMap[colors])] = true;
      }

      if (colorsMap[type]) {
        // mdf升级 => 兼容type属性接收colors
        clsObj["".concat(clsPrefix, "-").concat(colorsMap[type])] = true;
      }

      if (typeMap[type]) {
        clsObj["".concat(clsPrefix, "-text")] = typeMap[type] === 'link';
        clsObj["".concat(clsPrefix, "-").concat(typeMap[type])] = true;
      }

      if (danger) {
        clsObj["".concat(clsPrefix, "-danger")] = danger;
      }

      if (ghost) {
        clsObj["".concat(clsPrefix, "-ghost")] = ghost;
      }

      if (isBordered) {
        clsObj["".concat(clsPrefix, "-border")] = isBordered;
      }

      if (loading) {
        clsObj["".concat(clsPrefix, "-loading")] = loading;
      }

      if (icon) {
        clsObj["".concat(clsPrefix, "-icon-cls")] = true;

        if (!children && children !== 0) {
          clsObj["".concat(clsPrefix, "-icon-only")] = true;
        }

        if (loading && loadingText) {
          clsObj["".concat(clsPrefix, "-icon-only")] = false;
        }
      }

      var isIconNode = function isIconNode(child) {
        if (!child) return;

        if ( /*#__PURE__*/React.isValidElement(child)) {
          return /*#__PURE__*/React.createElement("span", {
            className: "".concat(clsPrefix, "-icon-cls-wrapper")
          }, icon);
        } else {
          return /*#__PURE__*/React.createElement("span", {
            className: "".concat(clsPrefix, "-icon-cls-wrapper")
          }, /*#__PURE__*/React.createElement(Icon, {
            type: icon
          }));
        }
      };

      var classes = classnames(clsPrefix, clsObj);
      var loadingIcon = /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-loading-wrapper")
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "uf-loadingstate"
      }));
      var beeIcon = isIconNode(icon);
      var hasChildOrLoadingText = !!children || children === 0 || loading && loadingText;

      if (type === 'link' && this.props.hasOwnProperty('href') && this.props.href !== undefined) {
        return /*#__PURE__*/React.createElement("a", _extends({
          type: htmlType,
          className: classes,
          disabled: isDisabled
        }, others), loading ? loadingIcon : beeIcon, hasChildOrLoadingText && /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-text-wrap")
        }, loading && loadingText ? loadingText : this.props.children));
      }

      return /*#__PURE__*/React.createElement("button", _extends({
        type: htmlType,
        className: classes,
        disabled: isDisabled
      }, omit(others, ["isText"])), loading ? loadingIcon : beeIcon, hasChildOrLoadingText && /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-text-wrap")
      }, loading && loadingText ? loadingText : this.props.children));
    }
  }]);

  return Button;
}(Component)) || _class);
Button.propTypes = propTypes;
export default Button;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-button/src/Button.js